<div class="page-container" *ngIf="form$ | async as form">
  <form [formGroup]="form" *ngIf="config$ | async as config">
    <h1>Hausanschluss-Bestellstrecke</h1>
    <ng-container *ngIf="info">
      <section>
        <app-hint-card [outlined]="true">
          <h2 style="margin-top: 1rem; margin-bottom: 0; padding-bottom: 0">
            Ihr Netzbetreiber benötigt noch folgende Information von Ihnen:
          </h2>
          <p>{{ info }}</p>
        </app-hint-card>
      </section>
    </ng-container>
    <ng-container *ngIf="introConfig$ | async as introHtml">
      <h2>Anmerkung zum Bestellprozess:</h2>
      <div [innerHTML]="introHtml | safeHtmlPipe"></div>
    </ng-container>
    <mat-stepper [orientation]="(stepperOrientation$ | async)!" [linear]="true">
      <mat-step [stepControl]="form.controls.connectionObject">
        <div class="order-request-wizard-step--{{ stepperOrientation$ | async }}">
          <ng-template matStepLabel>Anschlussobjekt</ng-template>
          <h2>Anschlussobjekt</h2>
          <app-connection-object
            *ngIf="!!config.area"
            [areaType]="AllAreaTypeEnum[config.area.toUpperCase()]"
            [inputForm]="form"
            [disableDevelopmentArea]="true"
            (gisDataEvent)="
              setAvailableAreas(
                $event.availableAreas,
                form.controls.connectionObject,
                model?.connectionObject
              )
            "></app-connection-object>
          <app-stepper-button-row
            [isStart]="true"
            (onNext)="form.controls.connectionObject.markAllAsTouched(); logData(form)" />
        </div>
      </mat-step>

      <mat-step [stepControl]="form.controls.contactData">
        <div class="order-request-wizard-step--{{ stepperOrientation$ | async }}">
          <ng-template matStepLabel>Kontaktdaten</ng-template>
          <app-order-request-wizard-contact-data
            [formGroup]="form.controls.contactData"
            [connectionChangeConfig]="config$ | async" />
          <app-stepper-button-row (onNext)="form.controls.contactData.markAllAsTouched(); logData(form)" />
        </div>
      </mat-step>

      <!--  Wenn verschiedene Formulare für unterschiedliche Types hinzukommen, sollte die Komponente dynamisch reingeladen werden
            Außerdem könnte man die FormGroup dann auch dynamisch injecten -->
      <ng-container *ngIf="config.connectionChangeRequestType === ConnectionChangeRequestTypeEnum.CHANGE">
        <mat-step [stepControl]="form.controls.connectionChangeOperations">
          <div class="order-request-wizard-step--{{ stepperOrientation$ | async }}">
            <ng-template matStepLabel>Was soll bei ihrer Anschlussänderung ausgeführt werden?</ng-template>
            <app-order-request-wizard-operations
              [formGroup]="form.controls.connectionChangeOperations"
              [connectionChangeConfig]="config$ | async" />
            <app-stepper-button-row
              (onNext)="form.controls.connectionChangeOperations.markAllAsTouched(); logData(form)" />
          </div>
        </mat-step>
      </ng-container>

      <mat-step [stepControl]="form.controls.technicalData">
        <div class="order-request-wizard-step--{{ stepperOrientation$ | async }}">
          <ng-template matStepLabel>Technische Informationen</ng-template>
          <app-order-request-wizard-technical-data
            [formGroup]="form.controls.technicalData"
            [operations]="operationsValue$ | async"
            [availableAreas]="availableAreas$ | async"
            [connectionChangeConfig]="config$ | async" />
          <app-stepper-button-row (onNext)="form.controls.technicalData.markAllAsTouched(); logData(form)" />
        </div>
      </mat-step>

      <mat-step [stepControl]="form.controls.additionalInformation">
        <div class="order-request-wizard-step--{{ stepperOrientation$ | async }}">
          <ng-template matStepLabel>Weitere Informationen</ng-template>
          <app-order-request-wizard-additional-info
            [formGroup]="form.controls.additionalInformation"
            [connectionChangeConfig]="config$ | async" />
          <app-stepper-button-row
            (onNext)="form.controls.additionalInformation.markAllAsTouched(); logData(form)" />
        </div>
      </mat-step>

      <mat-step [stepControl]="form.controls.acceptConditions">
        <div class="order-request-wizard-step--{{ stepperOrientation$ | async }}">
          <ng-template matStepLabel>Zusammenfassung</ng-template>
          <h2>Ihre angegebenen Daten</h2>
          <p>
            Bitte prüfen Sie nochmals alle Daten auf Vollständigkeit und Richtigkeit, bevor sie ihren Antrag
            absenden.
          </p>
          <app-order-request-wizard-data-summary [data]="summaryData$ | async" />
          <br />
          <app-external-privacy-form-field [control]="form.controls.acceptConditions" />
          <app-stepper-button-row
            [isEnd]="true"
            [submitButtonLabel]="
              (config.connectionChangeRequestType === ConnectionChangeRequestTypeEnum.TEMPORARY
                ? 'Temporären Anschluss'
                : ConnectionChangeRequestTypeDisplayValues[config.connectionChangeRequestType]?.name) +
              (token ? ' erneut' : '') +
              ' beantragen'
            "
            (onSubmit)="submitOrder(form)" />
        </div>
      </mat-step>
    </mat-stepper>
  </form>
</div>
